<template>
  <div class="mumber-view">
    <div class="member-menu">
      <mt-tabbar v-model='home_selected' class="common-footer">

        <mt-tab-item class='item-wrap ' :class="{ 'active': $route.name == item.routerName }"
          v-for="(item, index) in menuList" :key="index">
          <router-link :to="{ name: item.routerName }" class='item'>
            <span class='text'>{{ $t(item.text) }}</span>
          </router-link>
        </mt-tab-item>

      </mt-tabbar>
    </div>

    <div class="member-index">
      <router-view />
    </div>
  </div>
</template>

<script>
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
import flexLine from '../../flexLine'
import GuessLike from '../../GuessLike'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getMemberIndex, boxList, giftList, get_config } from '../../../api/member'
import { logout, signout, getMemberInfo } from '../../../api/member'
import { checkInviter } from '../../../api/memberInviter'
import { Toast, MessageBox } from 'mint-ui'
export default {
  name: 'MemberIndex',
  data() {
    return {
      home_selected: 'mumber_index_index',
      user: {},
      time: '',
      orderCount: {},
      isShow: true,
      box_dot: {},  //盲盒徽标
      gift_dot: {},  //礼品卡徽标
      email_to: '',
      menuList: [
        {
          routerName: 'MemberIndexIndex',
          text: 'Mine'
        },
        {
          routerName: 'MemberAccount',
          text: 'MyWallet'
        },
        {
          routerName: 'MemberProfileSet',
          text: 'Personal Info'
        },
        {
          routerName: 'MemberInviterManage',
          text: 'MyTeam'
        },
        {
          routerName: 'MemberCommission',
          text: 'MyCommission'
        },
        {
          routerName: 'GiftBoxList',
          text: 'GiftCard'
        },
        {
          routerName: 'MemberOrderList',
          text: 'MyOrders'
        },
        {
          routerName: 'BlindBoxList',
          text: 'BlindBox'
        },
        {
          routerName: 'MemberChangePassword',
          text: 'Change password'
        },
        {
          routerName: 'HomeLang',
          text: 'Language selection'
        },
        {
          routerName: 'MemberAddressList',
          text: 'Delivery Address'
        },
        {
          routerName: 'MemberContactUs',
          text: 'Contact us'
        },
        {
          routerName: 'MemberInviteFriends',
          text: 'Invite friends'
        },
        {
          routerName: 'MemberSignOut',
          text: 'SignOut'
        },
      ]
    }
  },
  components: {
    flexLine,
    IndexOrderItem,
    IndexManageItem,
    GuessLike
  },
  created: function () {
    this.utils.preloadImages(['https://ysmhh.s3.amazonaws.com/1.gif', 'https://ysmhh.s3.amazonaws.com/2.gif'])



    this.time = new Date().getTime()
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    if (this.isOnline) {
      boxList().then(
        response => {
          if (response && response.result) {
            this.box_dot = response.result
          }
        },
        error => { }
      )
      giftList().then(
        response => {
          if (response && response.result) {
            this.gift_dot = response.result
          }
        },
        error => { }
      )

      getMemberIndex().then(
        response => {
          if (response && response.result.member_info) {
            this.user = response.result.member_info
          }
        },
        error => { }
      )
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      config: state => state.config.config
    }),

    nickname() {
      let title = '登录/注册'
      if (this.isOnline) {
        if (
          this.user &&
          typeof this.user !== 'undefined' &&
          JSON.stringify(this.user) !== '{}'
        ) {
          title = this.user.member_nickname
        }
      }
      return title
    },
    getScore() {
      let score = '0'
      if (this.isOnline && this.user.member_points) {
        score = this.user.member_points
      }
      return score
    },
    // 预存款可用金额 通过store 进行获取
    getAvailablePredeposit() {
      let availablePredeposit = '0.00'
      if (this.isOnline && this.user.available_predeposit) {
        availablePredeposit = this.user.available_predeposit
      }
      return availablePredeposit
    },
    getlevelname() {
      let levelname = ''
      if (this.isOnline && this.user.level_name) {
        levelname = this.user.level_name
      }
      return levelname
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig',
    }),
    ...mapMutations({
      memberLogout: 'memberLogout',
    }),
    getEmail() {
      this.$router.push({ name: 'MemberContactUs' })
    },
    getIF() {
      this.$router.push({ name: 'MemberInviteFriends' })
    },
    signout() {
      this.$router.push({ name: 'MemberSignOut' })
    },
    logout() {
      logout(this.user.member_name).then(res => {
        this.memberLogout()
        this.$router.push({ name: 'HomeMemberLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    showLogin() {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goScoreList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPointList', query: { index: 0 } })
      } else {
        this.showLogin()
      }
    },
    goOrder() {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goBox() {
      if (this.isOnline) {
        this.$router.push({
          name: 'BlindBoxList'
        })
      } else {
        this.showLogin()
      }
    },
    setLang() {
      this.$router.push({ name: 'HomeLang' })
    },
    onRetrieve() {
      // this.$router.push({ name: 'HomeMemberForget' })
      this.$router.push({ name: 'MemberChangePassword' })
    },
    goGiftBoxList() {
      if (this.isOnline) {
        this.$router.push({
          name: 'GiftBoxList'
        })
      } else {
        this.showLogin()
      }
    },
    goGiftSave() {
      if (this.isOnline) {
        this.$router.push({
          name: 'GiftSave'
        })
      } else {
        this.showLogin()
      }
    },
    goProfileInfo() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberProfileSet' })
      } else {
        this.showLogin()
      }
    },
    goSetting() {
      this.$router.push({ name: 'MemberSetting' })
    },
    // 消息通知
    goNews() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberNoticeList' })
      } else {
        this.showLogin()
      }
    },
    // 我的关注
    goFavourite() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFavorite' })
      } else {
        this.showLogin()
      }
    },
    // 我的地址
    goAddress() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAddressList' })
      } else {
        this.showLogin()
      }
    },
    // 我的退款
    goReturn() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberOrderreturn' })
      } else {
        this.showLogin()
      }
    },
    goAccount() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAccount' })
      } else {
        this.showLogin()
      }
    },
    goCommission(e) {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberCommission', query: { indexe: e } })
      } else {
        this.showLogin()
      }
    },
    goPredeposit() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberPredepositList' })
      } else {
        this.showLogin()
      }
    },
    // 我的好友列表
    goFriendList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFriendList' })
      } else {
        this.showLogin()
      }
    },
    // 商家入驻
    goSellerJoinin() {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerJoinin1' })
      } else {
        this.showLogin()
      }
    },
    // 聊天列表
    goMemberChatList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberChatList' })
      } else {
        this.showLogin()
      }
    },
    // 我的订单评价
    goEvaluateList() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberEvaluateList' })
      } else {
        this.showLogin()
      }
    },
    // 发票管理
    goInvoice() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberInvoiceList' })
      } else {
        this.showLogin()
      }
    },
    // 跳转卖家管理中心
    goSellerInfo() {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerIndex' })
      } else {
        this.showLogin()
      }
    },
    // 分销管理中心
    goMemberInviterManage() {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberInviterManage' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    goMyCommission() {
      if (this.isOnline) {
        checkInviter().then(res => {
          this.$router.push({ name: 'MemberCommission' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        this.showLogin()
      }
    },
    // 意见反馈
    goMemberFeedback() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberFeedback' })
      } else {
        this.showLogin()
      }
    },
    // 虚拟订单
    goVrOrder() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else {
        this.showLogin()
      }
    },
    // 活动记录
    goMarketmanagelog() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberMarketmanagelog' })
      } else {
        this.showLogin()
      }
    },
    // 砍价活动
    gBargain() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBargainlist' })
      } else {
        this.showLogin()
      }
    },
    // 到货通知
    goArrivalnotice() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberArrivalnotice' })
      } else {
        this.showLogin()
      }
    },
    // 浏览历史
    goBrowse() {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberBrowseList' })
      } else {
        this.showLogin()
      }
    },
    gotobuy() {
      this.$router.push({ name: 'HomeGoBuy' })
    },
  }
}
</script>

<style scoped lang="scss">
.mumber-view {
  display: flex;
  justify-content: space-between;
  width: 1210px;
  padding: 20px 0;

  .member-menu {
    width: 200px;
    border: 1px solid #e7e7e7;

    .common-footer {
      flex-direction: column;

      .item-wrap {
        padding: 10px;
        border-bottom: 1px solid #e7e7e7;

        .text {
          color: #777;
        }
      }

      .active,
      .item-wrap:hover {
        background-color: #e7010c;
        padding-left: 30px;

        .text {
          color: #fff;
        }
      }
    }
  }

  .member-index {
    width: 1000px;
    border: 1px solid #e7e7e7;
  }
}
</style>
